// collection
export enum ECollection {
    MP_USERS = 'mp_users',
    MP_CITIES = 'mp_cities',
    MP_ORDERS = 'mp_orders',
    MP_PRODUCT_GROUPS = 'mp_product_groups',
    MP_PRODUCTS = 'mp_products',
    MP_PAYMENT_MODE = 'mp_payment_mode',
    MP_PAYMENT_TYPE = 'mp_payment_type',
    MP_PAYMENT_RECEIPTS = 'mp_payment_reciepts',
    MP_PAYMENT_LOGS = 'mp_payment_logs',
    MP_ITEM_DETAILS = 'mp_item_details',
    MP_FEEDBACK = 'mp_feedback',
    MP_TAXES = 'mp_taxes',
    MP_INVOICES = 'mp_invoices',
    MP_ADVERTISING = 'mp_advertising',
    MP_SLIDER_IMG_HOME = 'mp_slider_img_home',
    MP_ADVERTISING_MARQUEE = 'mp_advertising_marquee',
    MP_BANKS = 'mp_banks',
}
